import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { LayoutService } from '../layout.service';
import { StoriesService } from '../stories.service';

import { Story } from '../shared/interfaces/story';
import { User } from '../shared/interfaces/user';

@Component({
  selector: 'app-story',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './story.component.html',
  styleUrl: './story.component.scss'
})
export class StoryComponent {
  @Input() story!: Story
  @Input() user!: User | null
  @Output() showStoryRequest: EventEmitter<Story> = new EventEmitter()

  isDesktop = this.layoutService.isDesktop

  constructor(
    private layoutService: LayoutService,
    private storiesService: StoriesService
  ){}

  viewStory(story: Story){
    console.log('viewStory')
    if(story.reported) return

    this.storiesService.story.next(story)
    this.showStoryRequest.emit(story)
  }
}
